<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id="add_cpa"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#AdditionOfCPA"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Addition Of CPA</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="AdditionOfCPA">
        <div class="row">
            <!--CPA Cover Applicability* starts-->
            <div class=" col-lg-3 col-md-3 col-sm-6" v-if="additionOfCpaData.cpaApplicability.visibility">
              <div class="row form-group">
                <float-label label="CPA Cover Applicability*" :fixed="isFloat(additionOfCpaData.cpaApplicability.value)">
                  <select
                    class="form-control"
                    placeholder="CPA Cover Applicability*"
                    v-model="additionOfCpaData.cpaApplicability.value"
                    v-evolvews="additionOfCpaData.cpaApplicability"
                    :class="{ 'bgc-error-field': additionOfCpaData.cpaApplicability.errorText!=='' }"
                    disabled
                    >
                    <option disabled selected value>CPA Cover Applicability*</option>
                    <option disabled :value='null' v-if='additionOfCpaData.cpaApplicability.value == null'>CPA Cover Applicability*</option>
                    <option disabled value=''  v-if='additionOfCpaData.cpaApplicability.value == ""'>CPA Cover Applicability*</option>
                    <option v-for="cpaApplicability in domainValues.cpaApplicabilityResponse.cpaApplicabilityList" :key="cpaApplicability.code" :value="cpaApplicability.code">{{cpaApplicability.name}}</option>
                  </select>
                </float-label>
                <span
                  class="error-text"
                  v-if="additionOfCpaData.cpaApplicability.errorText !== ''"
                >{{ additionOfCpaData.cpaApplicability.errorText }}</span>
              </div>
            </div>
            <!--CPA Cover Applicability* ends-->
            <!--CPA Period* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="additionOfCpaData.cpaDuration.visibility">
              <div class="row form-group">
                <float-label label="CPA Period*" :fixed="isFloat(additionOfCpaData.cpaDuration.value)">
                  <select
                    class="form-control"
                    placeholder="CPA Period*"
                    v-model="additionOfCpaData.cpaDuration.value"
                    v-evolvews="additionOfCpaData.cpaDuration"
                    :class="{'bgc-error-field':additionOfCpaData.cpaDuration.errorText !== ''}"
                    @change="getSumInsured()"
                    >
                    <option disabled :value='null' v-if='additionOfCpaData.cpaDuration.value == null'>CPA Period*</option>
                    <option disabled value=''  v-if='additionOfCpaData.cpaDuration.value == ""'>CPA Period*</option>
                    <option v-for="cpaDuration in cpaDurationList" :key="cpaDuration" :value="cpaDuration">{{cpaDuration}}</option>
                  </select>
                </float-label>
                <span class="error-text" v-if="additionOfCpaData.cpaDuration.errorText !== ''">
                  {{additionOfCpaData.cpaDuration.errorText}}</span>
              </div>
            </div>
            <!--CPA Period* ends-->
            <!--PA Nominee Name starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="additionOfCpaData.paNomineeName.visibility">
                <div class="row form-group">
                    <float-label label="PA Nominee Name" :fixed="isFloat(additionOfCpaData.paNomineeName.value)"> 
                        <input
                            v-model="additionOfCpaData.paNomineeName.value"
                            v-evolvews="additionOfCpaData.paNomineeName"
                            type="text"
                            maxlength="30"
                            v-on:keydown="onlyCharSpace"
                            class="form-control"
                            placeholder="PA Nominee Name"
                        />
                    </float-label>
                    <span class="error-text" v-if="additionOfCpaData.paNomineeName.errorText !== ''">
                        {{additionOfCpaData.paNomineeName.errorText}}</span>
                </div>
            </div>
            <!--PA Nominee Name ends-->
            <!-- PA Nominee Relation starts-->
            <div class=" col-lg-3 col-md-3 col-sm-6" v-if="additionOfCpaData.paNomineeRelation.visibility">
                <div class="row form-group">
                    <float-label label="PA Nominee Relation" :fixed="isFloat(additionOfCpaData.paNomineeRelation.value)">
                        <select
                        class="form-control"
                        placeholder="PA Nominee Relation"
                        v-model="additionOfCpaData.paNomineeRelation.value"
                        v-evolvews="additionOfCpaData.paNomineeRelation"
                        >
                          <!-- <option disabled selected value>PA Nominee Relation</option> -->
                          <option disabled value='' v-if="additionOfCpaData.paNomineeRelation.value==''">PA Nominee Relation</option>
                          <option disabled :value='null' v-if="additionOfCpaData.paNomineeRelation.value==null">PA Nominee Relation</option>
                          <option v-for="relation in domainValues.initMotorDomainLists.nomineeRelations" :key="relation.code" :value="relation.code">{{relation.name}}</option>
                        </select>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="additionOfCpaData.paNomineeRelation.errorText !== ''"
                        >{{ additionOfCpaData.paNomineeRelation.errorText }}</span>
                </div>
            </div>
            <!-- PA Nominee Relation ends-->
            <!--Nominee DOB starts-->
            <!-- <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="row form-group">
                    <float-label label="Nominee DOB" :fixed="isFloat(additionOfCpaData.nomineeDob.value)">
                        <datepicker
                        v-model="additionOfCpaData.nomineeDob.value"
                        v-evolvews="additionOfCpaData.nomineeDob"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="Nominee DOB"
                        :input-class="isInputError(additionOfCpaData.nomineeDob.errorText)"
                        @selected="checkError(additionOfCpaData.nomineeDob,false)"
                        @input="checkError(additionOfCpaData.nomineeDob,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="additionOfCpaData.nomineeDob.errorText !== ''"
                    >{{additionOfCpaData.nomineeDob.errorText}}</span>
                </div>
            </div> -->
            <!--Nominee DOB ends-->
            <!--PA Nominee Allocation (%) starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="additionOfCpaData.paNomineeAllocationPercentage.visibility">
                <div class="row form-group">
                    <float-label label="PA Nominee Allocation (%)" :fixed="isFloat(additionOfCpaData.paNomineeAllocationPercentage.value)"> 
                        <input
                            v-model="additionOfCpaData.paNomineeAllocationPercentage.value"
                            v-evolvews="additionOfCpaData.paNomineeAllocationPercentage"
                            type="text"
                            v-on:keydown="onlyNumber"
                            disabled
                            @blur="checkError(additionOfCpaData.paNomineeAllocationPercentage)"
                            :class="{
                              'bgc-error-field':additionOfCpaData.paNomineeAllocationPercentage.errorText !=='',
                            }"
                            class="form-control"
                            placeholder="PA Nominee Allocation (%)"
                        />
                    </float-label>
                    <span class="error-text" v-if="additionOfCpaData.paNomineeAllocationPercentage.errorText !== ''">
                        {{additionOfCpaData.paNomineeAllocationPercentage.errorText}}</span>
                </div>
            </div>
            <!--PA Nominee Allocation (%) ends-->
        </div>
    </div>
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
  name: "AdditionOfCPA",
  props: ["additionOfCpaData", "domainValues",'cpaDurationList','getSavedQuoteData'],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber= functions.onlyNumber;
    const onlyCharSpace= functions.onlyCharSpace;
    function getSumInsured(){
      context.parent.getSumInsured(props.additionOfCpaData.cpaDuration.value);
    }
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.additionOfCpaData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      if(props.getSavedQuoteData.riskDetails.cpaApplicability !== 'S')
        context.parent.enableCalculatePremiumBtn('additionOfCpa');
    })
    return {
      state,
      isFloat,
      checkError,
      onlyNumber,
      onlyCharSpace,
      isInputError,
      getSumInsured
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
